<script setup lang="ts">
import type {
  InsightConfig,
  InsightConfigJsonField,
  InsightConfigMeta,
} from '../../../models/insightConfig.types'
import { INSIGHT_CONFIG_JSON_FIELD_SPECS } from '../../../service/insightConfig'

import { useI18n } from '@/shared/i18n'
import { JsonField } from '@/shared/ui/json-field'

defineModel<InsightConfig>('form', { required: true })
const json = defineModel<Record<InsightConfigJsonField, string>>('json', { required: true })
const props = defineProps<{
  meta: InsightConfigMeta
  errors: Record<string, string[]>
  disabled?: boolean
}>()
const { t } = useI18n()
const error = () =>
  (props.errors['impact_formula'] ?? [])
    .map((message) => (message.startsWith('insights.') ? t(message) : message))
    .join(' ')
</script>

<template>
  <fieldset class="config-section grid gap-md min-w-0 p-lg border border-border rounded-lg">
    <legend>{{ t('insights.sysadmin.config.section.impact') }}</legend>
    <JsonField
      :model-value="json.impact_formula"
      :spec="INSIGHT_CONFIG_JSON_FIELD_SPECS.impact_formula"
      :label="t('insights.sysadmin.config.fields.impactFormula')"
      :description="t('insights.sysadmin.config.jsonDescription.impactFormula')"
      :error-message="error()"
      :null-label="t('insights.sysadmin.config.setNull')"
      :default-label="t('insights.sysadmin.config.useDefault')"
      :disabled="disabled"
      @update:model-value="json = { ...json, impact_formula: $event }"
    />
  </fieldset>
</template>

<style scoped>
.config-section legend {
  padding-inline: var(--ui-space-xs);
  font-weight: 600;
}
</style>
